module.exports = __webpack_public_path__ + "static/media/homepage_background.e43da516.jpg";